import React, { useMemo } from 'react';
import RecordBadge, { RecordIdentity } from '../common/RecordBadge';
import ShareModal from '../common/ShareModal';
import TempShareLinkSection from '../common/TempShareLinkSection';
import { slugify } from '../../utils/strings';

const ItemShareModal = ({
	open = false,
	onClose,
	card,
	cardType = 'Item',
	title = 'Untitled item',
	shareUrl = '',
	itemId,
	// The collection this item belongs to, and the record carrying myAccess:
	// both are what the temporary-link section needs to offer (and gate) a
	// public link to this one item.
	collectionId,
	collection = null,
	qrFileNamePrefix = 'keepr-item',
}) => {
	const normalizedTitle = title || 'Untitled item';
	const downloadName = useMemo(() => {
		const slug = slugify(normalizedTitle);
		const suffix = itemId ? `-${itemId}` : '';
		return `${qrFileNamePrefix}${slug ? `-${slug}` : ''}${suffix || ''}`;
	}, [normalizedTitle, itemId, qrFileNamePrefix]);

	return (
		<ShareModal
			open={open}
			onClose={onClose}
			modalTitle="Share item"
			preview={(
				<RecordIdentity
					kicker={cardType}
					badge={<RecordBadge kind="item" record={card} title={normalizedTitle} collection={collectionId || null} />}
				/>
			)}
			shareUrl={shareUrl}
			downloadFileName={downloadName}
			extra={itemId ? (
				<TempShareLinkSection
					collectionId={collectionId}
					collection={collection}
					kind="item"
					itemId={itemId}
				/>
			) : null}
		/>
	);
};

export default ItemShareModal;
